import { render, staticRenderFns } from "./MainTab.vue?vue&type=template&id=cb985c40&"
import script from "./MainTab.vue?vue&type=script&lang=js&"
export * from "./MainTab.vue?vue&type=script&lang=js&"
import style0 from "./MainTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports